/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService, ResourceHelper } from '../../util/http-services';
import { ResourceQueryResult } from '../../util/services';
import { DisableRequest, IdentityMessage } from '../../util/messages';

/* eslint-enable */

@Injectable()
export class InvoiceTagResourceService extends BaseHttpService {

  // <editor-fold desc="CRUD">

  query(request: InvoiceTagResource.QueryRequest): Observable<ResourceQueryResult<InvoiceTagResource.InvoiceTag>> {
    return this.http.get<ResourceQueryResult<InvoiceTagResource.InvoiceTag>>(this.url, this.parseParams(request));
  }

  get(request: InvoiceTagResource.GetRequest): Observable<InvoiceTagResource.InvoiceTag> {
    return this.http.get<InvoiceTagResource.InvoiceTag>(this.url + `${request.id}`, this.parseParams(request));
  }

  create(request: InvoiceTagResource.CreateRequest): Observable<IdentityMessage> {
    return this.http.post<IdentityMessage>(this.url, request);
  }

  update(request: InvoiceTagResource.UpdateRequest): Observable<IdentityMessage> {
    return this.http.put<IdentityMessage>(this.url + `${request.id}`, request);
  }

  disable(request: DisableRequest): Observable<IdentityMessage> {
    return this.http.patch<IdentityMessage>(this.url + `${request.id}/disable`, request);
  }

  // </editor-fold>

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, '/invoices/invoice-tags/');
  }

}

export namespace InvoiceTagResource {

  // <editor-fold desc="CRUD">

  export interface QueryRequest {
    fields?: string;
    filter?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
    rights?: string;
    no_progress_bar?: boolean;
  }

  export interface InvoiceTag {
    id: number;
    granted_rights: string[];
    creation_time: string;
    update_time: string;
    invoice_tag: string;
    description?: string;
    disabled: boolean;
  }

  export interface GetRequest {
    id: number;
    fields?: string;
    rights?: string;
  }

  export interface CreateRequest {
    invoice_tag: string;
    description?: string;
  }

  export interface UpdateRequest {
    id: number;
    invoice_tag: string;
    description?: string;
  }

  // </editor-fold>

}
